import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection17Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/qm3u3f6y8v`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection17Video;
